import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/suggestion.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleSuggestionReviewsCreatedEvent } from './Types'
import { Link } from 'react-router-dom'
import { stopPropagation } from 'utils'

interface Props extends ActivityEventPosition {
  event: ArticleSuggestionReviewsCreatedEvent
}

const ArticleSuggestionReviewsCreated = ({ event, ...props }: Props) => {
  const {
    user,
    article,
    data: { branch, base_branch, message },
  } = event
  const isBaseBranch = base_branch.key === article.key

  const content = isBaseBranch ? (
    <>
      <Actor displayName={user.display_name || 'Anonymous user'} userId={user?.id} /> suggested changes on a linked
      copy:{' '}
      <Link to={branch.url} onClick={stopPropagation}>
        {branch.title}
      </Link>
    </>
  ) : (
    <>
      <Actor displayName={user.display_name || 'Anonymous user'} userId={user?.id} /> suggested changes on this linked
      copy
    </>
  )

  return (
    <BaseActivityEvent {...props} icon={<Icon />} timestamp={event.timestamp} content={content} message={message} />
  )
}

export { ArticleSuggestionReviewsCreated }
